import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Autocomplete from "react-google-autocomplete";
import { colors } from "../../utils/constants";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

interface GooglePlaceSearchComponentPropType {
  onPlaceSelected: (places: any | null) => void;
  countries?: string[];
  placeholder?: string;
  label?: string;
  isRequired?: boolean;
  isError?: boolean;
  errorMsg?: string;
  defaultValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
  disabled?: boolean;
  extraClasses?: string;
  isDarkBG?: boolean;
}

const GooglePlaceSearchComponent = ({
  onPlaceSelected,
  countries = ["ca"],
  placeholder = "Address",
  label = "Address",
  isRequired = false,
  errorMsg = "",
  isError = false,
  onChange = () => {},
  defaultValue = "",
  extraClasses = "",
  isDarkBG = false,
}: GooglePlaceSearchComponentPropType) => {
  const autoCompleteRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(defaultValue);

  // Keep the visible value in sync when the parent updates defaultValue
  useEffect(() => {
    if (defaultValue !== undefined && autoCompleteRef.current) {
      autoCompleteRef.current.value = defaultValue || "";
      setInputValue(defaultValue || "");
    }
  }, [defaultValue]);

  return (
    <>
      <Autocomplete
        itemType="text"
        className={`text-base text-docsigna-blue-dark font-medium block w-full rounded-md h-[44px] border border-docsigna-blue-dark shadow-none outline-none bg-transparent ${extraClasses} ${
          isDarkBG ? "!bg-white" : ""
        }`}
        apiKey={API_KEY}
        ref={autoCompleteRef}
        onEmptiedCapture={onChange}
        defaultValue={defaultValue}
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          const target = e.target as HTMLInputElement;
          setInputValue(target.value);
          // Create a ChangeEvent to match the expected type
          const changeEvent = {
            ...e,
            target,
          } as React.ChangeEvent<HTMLInputElement>;
          onChange(changeEvent);
        }}
        onPlaceSelected={place => {
          // When a place is selected, update the visible value to match the formatted address
          if (place?.formatted_address) {
            setInputValue(place.formatted_address);
            if (autoCompleteRef.current) {
              autoCompleteRef.current.value = place.formatted_address;
            }
          }
          onPlaceSelected(place);
        }}
        options={{
          types: ["address"],
          componentRestrictions: { country: countries },
        }}
      />
      {isError ? <p style={{ color: colors.Red }}>{errorMsg}</p> : null}
    </>
  );
};

export default GooglePlaceSearchComponent;
